// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xxgRv","label":"styles_label__1ppx5"};